import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';

import useGetQualificationsRowData from '../hooks/useGetQualificationsRowData';
import QualificationForm from './QualificationForm';

const CreateEditForm = ({ rowId, handleClose }: FormComponentProps) => {
  const { isFetching, data } = useGetQualificationsRowData(rowId);

  return isFetching ? (
    <DrawerFormSkeleton count={1} />
  ) : (
    <QualificationForm currentItem={data} handleClose={handleClose} />
  );
};

export default CreateEditForm;
